<app-titulo [modulo]="titulo" [mostrar]="true"></app-titulo>
<!--Se NO es editar se permite adcionar usuarios-->
<div class="container" *ngIf="!editar">
    <div class="row">
        <div class="col-md-3 ">
            <div class="mb-1 fw-bold">
                <label>Buscar usuario</label>
            </div>
            <div class="input-group">
                <span class="input-group-text fondo-blanco color-gris cursor" (click)="buscar(texto.value)"><i
                        class="fa-solid fa-magnifying-glass"></i></span>
                <input type="text" class="form-control lineas-buscadores" placeholder="Usuario" #texto id="caja">
                <span class="input-group-text fondo-blanco color-gris cursor" (click)="borrar()" id="cancel">
                    <i class="fa-solid fa-circle-xmark"></i>
                </span>
            </div>
        </div>
    </div>
    <div class="row justify-content-center mt-3">
        <div class="col-lg-12 mt-4">
            <table class="table mt-2" aria-describedby="mydesc">
                <thead class="fondo-gris">
                    <tr class="text-center">
                        <th scope="col-3">Nombre funcionario</th>
                        <th scope="col-3">Nombre usuario</th>
                        <th scope="col-2">Cargo</th>
                        <th scope="col-2">Área</th>
                        <th scope="col-2">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let usuario of usuarios | paginate: { itemsPerPage: 3, currentPage: pagina }"
                        class="text-center">
                        <td >{{ usuario.nombreUsuario }}</td>
                        <td>{{ usuario.email }}</td>
                        <td >{{ usuario.perfil }}</td>
                        <td >{{ usuario.area }}</td>
                        <td >
                            <a class="text-primary cursor me-3" (click)="addUsuario(usuario)">
                                <i class="fa-solid fa-circle-plus fa-lg cursor"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-end mt-2">
                <pagination-controls class="clase-paginador" (pageChange)="pagina = $event" previousLabel="Anterior"
                    nextLabel="Siguiente"></pagination-controls>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-left mt-1">
        <div class="card col-md-5 mt-1 ms-4 scroll-listas">
            <ul class="list-group col-md-12">
                <li class="list-group-item cursor" *ngFor="let item of listUsuarios; let i = index"
                    (dblclick)="quitarUsuario(i)">{{ item.nombreUsuario }}</li>
            </ul>
        </div>
    </div>
</div>
<!--Si es editar se coloca la información del usuario-->
<div class="container" *ngIf="editar">
    <div class="d-flex justify-content-center mt-2 py-1">
        <div class="d-flex col-md-5 me-5">
            <p class="mt-1 me-3" style="color: #266090;"><b>Nombre: </b>{{usuario.nombreUsuario}}</p>
        </div>
        <div class="d-flex col-md-5 ms-5">
            <p class="mt-1 me-3" style="color: #266090;"><b>Usuario: </b>{{usuario.email}}</p>
        </div>
    </div>
    <div class="d-flex justify-content-center mt-2 py-1">
        <div class="d-flex col-md-5 me-5">
            <p class="mt-1 me-3" style="color: #266090;"><b>Perfil: </b>{{usuario.perfil}}</p>
        </div>
        <div class="d-flex col-md-5 ms-5">
            <p class="mt-1 me-3" style="color: #266090;"><b>Área: </b>{{usuario.area}}</p>
        </div>
    </div>
</div>
<div class="container ">
    <div class="d-flex justify-content-center mt-1">
        <div class="d-flex col-md-5 me-3">
            <label class="azul-titulos fw-bold">Aplicaciones disponibles</label>
        </div>
        <div class="d-flex col-md-1">
        </div>
        <div class="d-flex col-md-5 ms-3">
            <label class="azul-titulos fw-bold">Aplicaciones seleccionadas</label>
        </div>
    </div>
    <div class="d-flex justify-content-center mt-1" >
        <div class="card col-md-5 mt-3 me-5 scroll-listas-2">
            <ul class="list-group">
                <li class="list-group-item cursor" *ngFor="let func of listAplicaciones; let i=index" value="{{ func.idAplicativo }}"
                    (click)="seleccionarAplicacionOrigen($event, i)"
                    [ngClass]="{'active': indiceAplicacionOrigen === func.idAplicativo}">
                    {{ func.nombreAplicativo }}
                </li>
            </ul>
        </div>
        <div class="mt-3 align-self-center flex-column">
            <div class="mb-3">
                <a class="text-primary cursor" (click)="agregarAplicacion()"><i class="fa-solid fa-circle-right fa-2x"></i></a>
            </div>
            <div class="mb-3">
                <a class="text-primary cursor" (click)="quitarAplicacion()"><i class="fa-solid fa-circle-left fa-2x"></i></a>
            </div>
        </div>
        <div class="card col-md-5 mt-3 ms-5 scroll-listas-2">
            <ul class="list-group">
                <li class="list-group-item cursor" *ngFor="let func of listAplicacionesDestino; let i=index"
                    value="{{ func.idAplicativo }}"
                    (click)="seleccionarAplicacionDestino($event, i)"
                    [ngClass]="{'active': indiceAplicacionDestino === func.idAplicativo}">
                    {{ func.nombreAplicativo }}
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="container ">
    <div class="d-flex justify-content-center mt-1">
        <div class="d-flex col-md-5 me-3">
            <label class="azul-titulos fw-bold">Roles disponibles</label>
        </div>
        <div class="d-flex col-md-1">
        </div>
        <div class="d-flex col-md-5 ms-3">
            <label class="azul-titulos fw-bold">Roles seleccionados</label>
        </div>
    </div>
    <div class="d-flex justify-content-center mt-1" >
        <div class="card col-md-5 mt-3 me-5 scroll-listas-2">
            <ul class="list-group">
                <li class="list-group-item cursor" *ngFor="let func of listRoles; let i=index" value="{{ func.idRol }}"
                    (click)="seleccionarRolOrigen($event, i)"
                    [ngClass]="{'active': indiceRolOrigen === func.idRol}">
                    {{ func.nombreRol }}
                </li>
            </ul>
        </div>
        <div class="mt-3 align-self-center flex-column">
            <div class="mb-3">
                <a class="text-primary cursor" (click)="agregarRol()"><i class="fa-solid fa-circle-right fa-2x"></i></a>
            </div>
            <div class="mb-3">
                <a class="text-primary cursor" (click)="quitarRol()"><i class="fa-solid fa-circle-left fa-2x"></i></a>
            </div>
        </div>
        <div class="card col-md-5 mt-3 ms-5 scroll-listas-2">
            <ul class="list-group">
                <li class="list-group-item cursor" *ngFor="let func of listRolesDestino; let i=index"
                    value="{{ func.idRol }}"
                    (click)="seleccionarRolDestino($event, i)"
                    [ngClass]="{'active': indiceRolDestino === func.idRol}">
                    {{ func.nombreRol }}
                </li>
            </ul>
        </div>
    </div>
    <div class="d-flex content-center mt-4 mb-5">
        <div class="d-flex justify-content-end col-md-7">
            <div class="me-2">
                <button class="btn btn-primary" (click)="guardar()">GUARDAR</button>
            </div>
            <div class="ms-2">
                <button class="btn btn-secondary" (click)="cancelar()">CANCELAR</button>
            </div>
        </div>
    </div>
</div>
